import React, { PropTypes } from 'react';
import classNames from 'classnames';

export const HORIZONTAL = 'horizontal';
export const VERTICAL = 'vertical';


const GROUP_PROPTYPES = {
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  invalid: PropTypes.bool.isRequired
};

const VerticalGroup = ({ label, id, children, invalid }) => (
  <div className={classNames("form-group", { 'has-danger': invalid })}>
    {label && <label htmlFor={id}>{label}</label>}
    {children}
  </div>
);

VerticalGroup.propTypes = GROUP_PROPTYPES;

const HorizontalGroup = ({ label, id, children, invalid, labelClass, fieldClass }) => (
  <div className={classNames("form-group row", { 'has-danger': invalid })}>
    {label && (
      <label htmlFor={id} className={classNames("col-form-label", labelClass)}>
        {label}
      </label>
    )}
    <div className={fieldClass}>
      {children}
    </div>
  </div>
);

HorizontalGroup.propTypes = {
  ...GROUP_PROPTYPES,
  labelClass: PropTypes.string.isRequired,
  fieldClass: PropTypes.string.isRequired,
};

HorizontalGroup.defaultProps = {
  labelClass: 'col-sm-3',
  fieldClass: 'col-sm-9'
}

const InputGroup = ({ direction, ...rest }) => (
  direction === HORIZONTAL
    ? <HorizontalGroup {...rest} />
    : <VerticalGroup {...rest} />
);

InputGroup.propTypes = {
  ...GROUP_PROPTYPES,
  direction: PropTypes.oneOf([HORIZONTAL, VERTICAL]).isRequired,
};

InputGroup.defaultProps = {
  direction: HORIZONTAL,
  invalid: false
};

export default InputGroup;



// WEBPACK FOOTER //
// ./src/components/Form/InputGroup.js